import { SubscriptionType } from 'common/constants/subscription';
import {
  CompanySubscriptionModel,
  CompanySubscriptionModelC,
} from 'unit-account/interfaces/company-subscription-model';
import { CommonApi, CompanyResourcesApi } from '../../../api/server';
import { CompaniesC, Company } from '../../../units/account/interfaces/company';
import { CompanyBillingInfoModel, CompanyBillingInfoModelC } from '../interfaces/company-billing-info-model';
import { CreateSubscriptionForm } from '../interfaces/create-subscription-form';
import { EstimateSubscriptionForm } from '../interfaces/estimate-subscription-form';
import { EstimateSubscriptionModel, EstimateSubscriptionModelC } from '../interfaces/estimation-subscription-model';
import {
  SubscriptionPlanListingModel,
  SubscriptionPlanListingModelC,
} from '../interfaces/subscription-plan-listing-model';
import { UpdateSubscriptionForm } from '../interfaces/update-subscription-form';

function getSubscriptionPlans(subscriptionType?: SubscriptionType): Promise<SubscriptionPlanListingModel> {
  const type = subscriptionType ?? SubscriptionType.Modular;
  return CommonApi.getV(
    `/billing/${type}/plans`,
    SubscriptionPlanListingModelC,
    'Error while fetching subscription plans from backend',
  );
}

function setSubscriptionPaymentMethod(subscriptionId: string, cardId: string): void {
  CompanyResourcesApi.put(
    `/subscription/${subscriptionId}/payment/${cardId}`,
    null,
    'Error while set subscription payment method',
  );
}

function createSubscription(companyId: number, createSubscriptionForm: CreateSubscriptionForm): Promise<Company[]> {
  return CommonApi.postV(
    `/companies/${companyId}/subscription`,
    createSubscriptionForm,
    CompaniesC,
  );
}

function updateSubscription(
  subscriptionId: string,
  createSubscriptionForm: UpdateSubscriptionForm,
): Promise<CompanySubscriptionModel> {
  return CompanyResourcesApi.putV(
    `/subscription/${subscriptionId}`,
    createSubscriptionForm,
    CompanySubscriptionModelC,
  );
}

function cancelSubscription(subscriptionId: string): void {
  CompanyResourcesApi.post(
    `/subscription/${subscriptionId}/cancel`,
    null,
  );
}

function renewSubscription(subscriptionId: string): Promise<void> {
  return CompanyResourcesApi.post(
    `/subscription/${subscriptionId}/reactivate`,
    null,
  );
}

function getUpdateSubscriptionEstimation(
  subscriptionId: string,
  form: EstimateSubscriptionForm,
): Promise<EstimateSubscriptionModel> {
  return CompanyResourcesApi.postV(
    `/subscription/${subscriptionId}/estimate`,
    form,
    EstimateSubscriptionModelC,
  );
}

function getCreateSubscriptionEstimation(
  subscriptionType: SubscriptionType,
  form: EstimateSubscriptionForm,
): Promise<EstimateSubscriptionModel> {
  return CommonApi.postV(
    `/billing/${subscriptionType}/subscription/estimate`,
    form,
    EstimateSubscriptionModelC,
    'Error while  get create subscription estimation',
  );
}

function getBillingInfo(subscriptionType: SubscriptionType): Promise<CompanyBillingInfoModel> {
  return CommonApi.getV(
    `/user/billing/info/${subscriptionType}`,
    CompanyBillingInfoModelC,
    'Error while fetching user\'s own company billing info');
}

export const SubscriptionApi = {
  getSubscriptionPlans,
  createSubscription,
  updateSubscription,
  cancelSubscription,
  renewSubscription,
  setSubscriptionPaymentMethod,
  getUpdateSubscriptionEstimation,
  getCreateSubscriptionEstimation,
  getBillingInfo,
};
